export class AddEvents extends Phaser.Events.EventEmitter {

    constructor(element, events, handler, context) {
        super(element, events, handler, context);

        events.forEach(event => {
            if (typeof handler === 'object') {
                element.on(event, handler[event], context)
            } else {
                element.on(event, handler, context)
            }

        })
    }

    set newEvent(event) {
        this.on(event, this.handler, this.context)
    }
}